



































































































































































































































































































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
import { TbCoupon, TbMember, TbOrderPad, TbSettingsPad, TbShop, TbShopAccount } from '@/http';
import { tailFun } from '@/common/util/tailPad';
import { Toast } from 'vant';
import { logoutPanel,dialogPanel,openingPrompt } from "@/components";
import selectCoupon from "./selectCoupon.vue";
import scanPanel from "./scanPanel.vue";
import payPanel from "./payPanel.vue";
import payResultPanel from "./payResultPanel.vue";
import couponPop from "./couponPop.vue";
import morePay from "./morePay.vue";
import Bus from '@/common/util/bus';
import {PrintEvent1,PrintEvent3} from "@/common/util/prints";
import {TbShopReceiptTemplate} from "@/http/api_TbShopReceiptTemplate"
import JsBarcode from 'jsbarcode';
const { userAgent } = navigator;
  const isAndroid =
    userAgent.indexOf("Android") > -1 ||
    userAgent.indexOf("android") > -1 ||
    userAgent.indexOf("Adr") > -1; // android终端
@Component({
    components: {
        logoutPanel,selectCoupon,scanPanel,dialogPanel,payPanel,payResultPanel,couponPop,openingPrompt,morePay
    },
})
export default class settlementDesk extends Vue {
    public $refs: {
    };

    fmoney = fmoney;

    /**整单优惠相关 */
    /**仅享受整单折扣 */
    isOnlyZdZk = false;
    /**整单优惠方式
     * 1：整单一口价
     * 2：整单折扣
     */
    zdyhVal = 1;
    get zdyhLabel(){
        let str = "";
        str = this.zdyhVal==1?"整单一口价":"整单折扣";
        return str;
    }

    /**整单折扣一口价 */
    discountPrice=0
    /**整单折扣 */
    discount=0;
    /**整单下拉 */
    showZdPopover = false;
    zdOptions = [
        {
            label:"整单一口价",
            value:1,
        },
        {
            label:"整单折扣",
            value:2,
        },
    ]

    /**收银员列表 */
    staffList=[];
    staffListAll=[];

    userInfo:any={};

    /**是否打印小票 */
    isPrint = true;

    /**键盘 */
    config={
        loop : [
            {
                number : 1,
                key : 'number-1',
            },
            {
                number : 2,
                key : 'number-2',
            },
            {
                number : 3,
                key : 'number-3',
            },
            {
                number : 4,
                key : 'number-4',
            },
            {
                number : 5,
                key : 'number-5',
            },
            {
                number : 6,
                key : 'number-6',
            },
            {
                number : 7,
                key : 'number-7',
            },
            {
                number : 8,
                key : 'number-8',
            },
            {
                number : 9,
                key : 'number-9',
            },
        ]
    }
    value = null;
    maxLength = 8;
    isNeedDot = true;

    /**更多支付方式 */
    morePayShow = false;
    isHasMorePay = false;
    morePaySetting = null;
    hasOfflineWeChat = false;
    hasOfflineAlipay = false;
    isFinishCalc=false;

    @Prop({
        type:Object,
        default:()=>{
            return{
                changeIntegral:0,
                rate:0,
                items:[]
            }
        }
    })
    calcOrderInfo;

    gwList=[];

    /**抹零配置 */
    /**roundType
     * 0:缺省
     * 1是到元  2是到角
     */
    mlSetting:any={
        isRound:null,
        roundType:null,
    };

    @Prop({
        default:""
    })
    gwListStr:String;
    @Watch("gwListStr")
    gwListStrChange(val){
        this.gwList = val? JSON.parse(val):[];
    }

    /**支付方式 */
    cashVal=0;
    vipVal=0;
    wechatVal=0;
    aliVal=0;
    /**选中的支付方式
     * 支持多选，最多三个
     * 1：现金
     * 2：会员卡
     * 3：微信
     * 4：支付宝
     */
    selectedPayType=[];
    /**默认支付方式 */
    defaultPayType = null;
    /**支付审核信息 */
    isAli = false;
    isWechat = false;
    auditInfo:any={};

    /**是否开启组合支付 */
    isGroupPay = false;
    /**收银设置 */
    paySetting:any={};

    /**当前选中输入框-数字键盘选中用
     * 1:整单一口价
     * 2：整单折扣
     * 3：现金
     * 4：会员卡
     * 5：微信
     * 6：支付宝
     */
    inputType=null;
    /**输入框是否选中，首次点击输入框，清空数值用 */
    isInputSelected = false;

    /**扫描优惠券 */
    couponShow = false;
    popCouponForm:any={};
    isCouponOff = false;
    couponSdObj:any={};
    isSking=false;
    prBtnTxt = "确定"

    /** 动态轮询定时器 */
    pollTimer= null;
    /** 未获取到支付结果-超时弹窗 */
    payovertimeShow= false;
    /** 用户手动取消轮询标志 */
    isPayCanceled= false;

    /**应收总额-抹零后 */
    get receivables(){
        let val = 0;
        let total = 0;
        let arr=this.gwList.filter(v=>v.finalPrice).map(v=>v.finalPrice);
        if(arr.length>0){
            total = arr.reduce((a,b)=>calculate.addition(Number(a),Number(b)));
            /**配置开启了抹零 */
            if(this.mlSetting.isRound){
                val = this.mlSetting.roundType==1? Number(tailFun(total,0)):Number(tailFun(total,1));
            }else{
                val = total;
            }
        }
        return val;
    }
    /**应收总额-抹零前 */
    get receivablesNoMl(){
        let val = 0;
        let total = 0;
        let arr=this.gwList.filter(v=>v.finalPrice).map(v=>v.finalPrice);
        if(arr.length>0){
            total = arr.reduce((a,b)=>calculate.addition(Number(a),Number(b)));
            val = total;
        }
        return val;
    }
    /**优惠券应收总额-排除无码商品加赠品 */
    // get couponReceivables(){
    //     let val = 0;
    //     let total = 0;
    //     let arr=this.gwList.filter(v=>v.finalPrice&&!v.isNoCode&&!v.isGift).map(v=>v.finalPrice);
    //     if(arr.length>0){
    //         total = arr.reduce((a,b)=>calculate.addition(Number(a),Number(b)));
    //         val = total;
    //     }
    //     return val;
    // }
    couponReceivables = 0;
    /**实收总额 */
    get receiptTotal(){
       let val = 0;
       let cashVal = this.cashVal?this.cashVal:0;
       let vipVal = this.vipVal?this.vipVal:0;
       let wechatVal = this.wechatVal?this.wechatVal:0;
       let aliVal = this.aliVal?this.aliVal:0;
       val = calculate.addition(calculate.addition(calculate.addition(Number(cashVal),Number(vipVal)),Number(wechatVal)),Number(aliVal));
       return val;
    }

    /**会员信息 */
    @Prop({
        type:Object,
        default:()=>{
            return {
                balance:0
            }
        }
    })
    memberInfo:any;

    /**优惠券id */
    memberCouponId = "";
    couponName = "";
    couponInfo:any={};
    /**使用优惠券优惠金额 */
    yhAmount = 0;
    /**是否开启会员抵扣 */
    isDeduction = false;
    /**使用会员积分 */
    useIntegral = 0;
    /**会员积分抵扣金额 */
    pointDeduction=0;

    /**会员积分配置 */
    memberIntegalSetting:any={};
    jf = 0;
    dikou=0;

    @Prop({
        default:0
    })
    priceTotal:Number;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    /**选择优惠券弹窗 */
    couponList = {
        /**可用优惠券列表 */
        availableList:[],
        /**不可用优惠券列表 */
        notAvailableList:[],
        /**购物车列表-计算优惠金额用 */
        gwList:[]
    };
    showCoupon = false;

    /**扫描优惠券-弹窗 */
    scanShow = false;

    /**当前选中收银员 */
    cashierId = "";
    /**选择本单收银员-弹窗 */
    diaCashierShow=false;
    popStaffId="";

    /**收款操作 */
    btnloading = false;
    /**收款倒计时 */
    count = 0;
    interval=null;
    /**收款后，产生的订单 */
    orderInfo:any = {};

    /**找零 */
    get changeVal(){
        let val = 0;
        if(this.selectedPayType.length==1&&this.selectedPayType.some(v=>v==1)){
            if(Number(this.receiptTotal)>Number(this.receivables)){
                val = calculate.subtraction(this.receiptTotal,this.receivables)
            }
        }
        return val;
    }
    get isGetChangePrice(){
        let val = false;
        if(this.gwList.length>0&&this.gwList.some(v=>v.isChangePrice===true)){
            val = true;
        }
        return val;
    }

    /**支付弹窗 */
    payShow = false;
    /**支付结果弹窗 */
    resultShow = false;
    payResult = true;
    errorCode = "";
    errorMessage = "";

    isPrintLoading = false;
    isStartPaying = false;
    isShowQueryBot = false;
    payMethodChangeMsg = "";

    /**匹配移动支付方式名称 */
    get getYdPayname(){
        let str = "微信/支付宝";
        if(this.selectedPayType.findIndex(v=>v==3)>-1){
            str = "微信";
        }else if(this.selectedPayType.findIndex(v=>v==4)>-1){
            str = "支付宝";
        }
        return str;
    }

    async created() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
        this.gwList = this.gwListStr? JSON.parse(this.gwListStr):[];
        Promise.all([
            this.getMlSet(),
            this.getStaffList(this.userInfo.id),
            this.getPrintSet(),
            await this.getPaySet(),
            await this.getMorePaySet(),
            await this.getMemberIntegralSet(),
            await this.getApproveStatus(),
            await this.getDefaultPayMethod(),
            await this.calcMember(),
        ]).then(()=>{
            this.isFinishCalc = true;
        }).catch(()=>{
            this.isFinishCalc = true;
        })
        this.discountPrice = Number(this.priceTotal);
    }

    mounted() {
        // Bus.$emit('watchCouponScan',true);
        Bus.$on('returnScanCouponResult',(val)=>{
            if(val){
                this.popCouponForm = val;
                this.couponSdObj={
                    isSingle:this.isOnlyZdZk,
                    isWholeOrderDiscount:this.zdyhVal==1?false:true,
                    wholeOrderDiscountPrice: this.discountPrice==0?0:this.discountPrice?this.discountPrice:this.priceTotal,
                    orderDiscount:this.discount? calculate.multiplication(this.discount,0.01):0,
                    isDeduction:this.isDeduction,
                    useIntegral:this.isDeduction?this.useIntegral:0,
                    pointDeduction:this.isDeduction?this.pointDeduction:0,
                }
                if(!localStorage.getItem("receivablesByCoupon")){
                    localStorage.setItem('receivablesByCoupon',this.receivablesNoMl.toString());
                }
                this.couponShow = true;
                this.closeScan();
            }else{
                this.isCouponOff = true;
            }
        })

        Bus.$on('payFalse',(val)=>{
            if(val){
                this.btnloading = false;
                this.payResult = false;
                if(this.$refs['payPanel']){
                    this.$refs['payPanel'].closeFun();
                }
                this.resultShow = true;
            }
         })
    }

    beforeUnmount() {
        clearTimeout(this.pollTimer);
        this.pollTimer = null;
        Bus.$off('returnScanCouponResult');
        Bus.$off('payFalse');
    }
    // 微信/支付宝  支付
    async startPay(val){

        if(this.isStartPaying) return;
        this.isStartPaying = true;
        Bus.$emit('isScaning',true);
        // this.orderInfo= {};
        // await this.postorder();
        // await Toast(this.orderInfo.id)

        // this.isStartPaying = false;
        // return;
        // this.closePay();

        if(this.orderInfo.id){
            try {
                let res = await TbOrderPad.OrderPayV5({
                    authCode:val,
                    id:this.orderInfo.id,
                    spbillCreateIp:''
                })
                // this.$refs['payPanel'].closeFun();

                // await this.printTest(this.orderInfo.id);
                if(!res.needPoll){
                  if(res.errorCode){
                      this.$refs['payPanel'].closeFun();
                      this.errorCode = res.errorCode;
                      this.btnloading = false;
                      this.payResult = false;

                      this.resultShow = true;
                      this.isStartPaying = false;
                      this.isShowQueryBot = false;
                      Bus.$emit('isScaning',false);
                  }else{
                      // if(this.$refs['payPanel']){
                      //     this.$refs['payPanel'].closeFun();
                      // }
                      this.$refs['payPanel'].closeFun();
                      this.payResult = res.isSuccessPay;
                      this.errorMessage = res.err_Msg;
                      this.payMethodChangeMsg = res.payMethodChangeMsg;
                      this.resultShow = true;
                      this.morePayShow = false
                      this.isStartPaying = false;
                      this.isShowQueryBot = res.isShowQueryBot;
                      Bus.$emit('isScaning',false);
                  }
                }else{
                  /** 需要轮询订单状态，支付弹窗保持打开，等待支付结果 */
                  this.payResult = false;
                  this.schedulePolling();
                }



            } catch (error) {
                this.$refs['payPanel'].closeFun();
                this.errorCode = error.errorCode;
                this.btnloading = false;
                this.payResult = false;

                this.resultShow = true;
                this.isStartPaying = false;
                this.isShowQueryBot = false;
                Bus.$emit('isScaning',false);
            }
        }
        return;
    }

    /** 启动动态轮询：5秒后开始首次查询 */
    		schedulePolling(){
          this.isPayCanceled = false;
    			this.pollTimer = setTimeout(async () => {
    				await this.getOrderPayStatus();
    			}, 5000);
    		}
        /** 用户手动取消轮询 */
        cancelPolling(){
          this.isPayCanceled = true;
          clearTimeout(this.pollTimer);
          this.pollTimer = null;
          this.isStartPaying = false;
          Bus.$emit('isScaning',false);
        }
    		async getOrderPayStatus(){
          /** 用户已手动取消，停止查询 */
          if(this.isPayCanceled) return;
    			/** 支付弹窗已关闭（倒计时走完），停止轮询并兜底查询一次，防止支付成功但被超时覆盖 */
    			if(!this.$refs['payPanel'] || !this.$refs['payPanel'].isPaying){
    				this.pollTimer = null;
    				await this.finalPayStatusCheck();
    				return;
    			}
    			let res;
    			try {
    				res = await TbOrderPad.GetOrderStatusV2({orderId:this.orderInfo.id});
    				// console.log('getOrderPayStatus',res);
    			} catch (error) {
    				console.log('error',error,this.orderInfo.id);
    				/** 轮询接口异常（断网/接口报错）：不中断轮询，按剩余倒计时继续重试，倒计时走完再兜底查询 */
    				const count2 = this.$refs['payPanel'] ? this.$refs['payPanel'].count2 : 0;
    				if(count2<=0){
    					await this.finalPayStatusCheck();
    				}else{
    					const delay = count2 > 10 ? 10000 : 5000;
    					this.pollTimer = setTimeout(async () => {
    						await this.getOrderPayStatus();
    					}, delay);
    				}
            return;
    			}
    			/**
    			 * 0 = None，缺省值
    			 * 1 = Wait，待支付
    			 * 2 = Success，支付成功
    			 * 3 = Failed，支付失败
    			 * 4 = Closed，已关闭
    			 */
    			if(res.orderStatus==2){
    				/** 支付成功 */
    				this.$refs['payPanel'].closeFun();
    				this.payResult = true;
    				this.resultShow = true;
    				this.morePayShow = false;
    				this.isStartPaying = false;
    				Bus.$emit('isScaning',false);

    			}else if(res.orderStatus==3||res.orderStatus==4){
    				/** 支付失败或已关闭 */
    				// this.handlePollFail();

            this.$refs['payPanel'].closeFun();
            this.errorCode = res.errorCode;
            this.errorMessage = res.error_Message;
            this.btnloading = false;
            this.payResult = false;

            this.resultShow = true;
            this.isStartPaying = false;
            this.isShowQueryBot = true;
            Bus.$emit('isScaning',false);
    			}else{
    				/** 待支付/缺省：按剩余时间动态间隔继续轮询，剩余>10秒每隔10秒，剩余<=10秒每隔5秒 */
    				const count2 = this.$refs['payPanel'] ? this.$refs['payPanel'].count2 : 0;
    				if(count2<=0){
    					/** 倒计时走完仍无结果：兜底查询一次 */
    					await this.finalPayStatusCheck();
    				}else{
    					const delay = count2 > 10 ? 10000 : 5000;
    					this.pollTimer = setTimeout(async () => {
    						await this.getOrderPayStatus();
    					}, delay);
    				}
    			}
    		}
    		/** 轮询失败/超时未取到订单状态：与 settlementDesk (2).vue 一致，展示"未获取到支付结果"超时弹窗 */
    		handlePollFail(){
    			clearTimeout(this.pollTimer);
    			this.pollTimer = null;
    			if(this.$refs['payPanel']){
    				this.$refs['payPanel'].closeFun();
    			}
    			this.isStartPaying = false;
    			Bus.$emit('isScaning',false);
    			this.payovertimeShow = true;
    		}
    		/** 倒计时结束后的最后一次查询，防止支付成功但被超时覆盖 */
    		async finalPayStatusCheck(){
          /** 用户已手动取消，停止查询 */
          if(this.isPayCanceled) return;
          Toast.loading({
              message: "查询中",
              duration: 0, // toast不消失
          });
    			let res;
    			try {
    				res = await TbOrderPad.GetOrderStatusV2({orderId:this.orderInfo.id});
    			} catch (error) {
    				Toast.clear();
    				this.handlePollFail();
    				return;
    			}
    			if(res.orderStatus==2){
    				/** 支付成功 */
    				Toast.clear();
    				if(this.$refs['payPanel']){
    					this.$refs['payPanel'].closeFun();
    				}
    				this.payResult = true;
    				this.resultShow = true;
    				this.morePayShow = false;
    				this.isStartPaying = false;
    				Bus.$emit('isScaning',false);

    			}else if(res.orderStatus==3||res.orderStatus==4){
            Toast.clear();
            this.$refs['payPanel'].closeFun();
            this.errorCode = res.errorCode;
            this.btnloading = false;
            this.payResult = false;

            this.resultShow = true;
            this.isStartPaying = false;
            this.isShowQueryBot = true;
            this.errorMessage = res.error_Message;
            Bus.$emit('isScaning',false);
          }else{
    				/** 确实未支付成功 */
    				Toast.clear();
    				this.handlePollFail();

    			}
    		}
    /**开启会员积分抵扣 */
    changeIntegal(){
        if(!this.memberInfo.id)return;
        if(!this.memberIntegalSetting.isOpen)return;
        if(!this.useIntegral)return;
        setTimeout(()=>{
            this.isDeduction = !this.isDeduction;
            if(this.isDeduction){
                this.inputType = null;
                this.isInputSelected = false;
            }
            this.calcFun();
            setTimeout(()=>{
                this.setPayal();
            },2000)
        },2000)
    }
    /**会员积分&&抵扣 */
    calcMember(){
        let jf = 0;
        let dikou = 0;
        let minValue = 0;
        let jfnum = this.memberIntegalSetting.per;
        let money1 = this.memberInfo.id? parseInt(Number(calculate.division(this.memberInfo.integral,jfnum))):0;
        let money2 = this.memberIntegalSetting.topLimit;
        let money3 = Number(tailFun(this.receivablesNoMl,0));
        if(money2) {
            minValue = Math.min(money1, money2, money3);
        }else{
            minValue = Math.min(money1, money3);
        }
        this.useIntegral = calculate.multiplication(minValue,jfnum);
        this.pointDeduction = Number(minValue);

    }
    groupPayChange(val){
        this.getDefaultPayMethod();
    }
    /**获取会员积分配置 */
    async getMemberIntegralSet(){
        let res = await TbSettingsPad.GetTbSettings({settingtype:9});
        this.memberIntegalSetting = res.settingContent;
    }
    /**获取默认支付方式 */
    async getDefaultPayMethod(){
        if(this.memberInfo.id){
            if(this.paySetting.memberCard&&this.memberInfo.balance>=this.receivables){
                this.selectedPayType=[2];
                this.vipVal = Math.min(this.memberInfo.balance,this.receivables);
                this.cashVal = 0;
                this.wechatVal=0;
                this.aliVal=0;
                this.defaultPayType=2;
            }else{
                this.searchDefaultPay();
            }
        }else{
            this.searchDefaultPay();
        }
        // console.log('selectedPayType',this.selectedPayType);
    }
    searchDefaultPay(){
        if(this.paySetting.paymentMethod){
            switch (this.paySetting.paymentMethod.value) {
                case "1":
                    this.selectedPayType=[1];
                    this.cashVal = this.receivables;
                    this.vipVal=0;
                    this.wechatVal=0;
                    this.aliVal=0;
                    this.defaultPayType=1;
                    break;
                case "2":
                    this.selectedPayType=[3];
                    this.wechatVal = this.receivables;
                    this.cashVal=0;
                    this.vipVal=0;
                    this.aliVal=0;
                    this.defaultPayType=3;
                    break;
                case "3":
                    this.selectedPayType=[4];
                    this.aliVal = this.receivables;
                    this.cashVal=0;
                    this.vipVal=0;
                    this.wechatVal=0;
                    this.defaultPayType=4;
                    break;

                default:
                    break;
            }
        }else{
            this.selectedPayType=[1];
            this.cashVal = this.receivables;
            this.vipVal=0;
            this.wechatVal=0;
            this.aliVal=0;
            this.defaultPayType=1;
        }
    }
    /**获取支付审核状态 */
    async getApproveStatus(){
        let res = await TbShop.GetTbShopApproveInfoByShopNo();
        this.auditInfo = res;
        this.isAli = res&&res.alipayApproveStatus == 3 ? true : false;
        this.isWechat = res&&res.approveStatus == 3 ? true : false;
    }
    /**获取抹零配置 */
    async getMlSet(){
        let res = await TbSettingsPad.GetTbSettings({settingtype:4});
        this.mlSetting = res.settingContent;
    }
    /**获取打印配置 */
    async getPrintSet(){
        let shopInfo = JSON.parse(localStorage.getItem("padShopInfo"));
        let resShop = await TbShop.GetInitShopInfo({shopid:shopInfo.id});
        let isnewReceipt = resShop.webShopReceiptTemplateType;

        if(isnewReceipt==0){
            let res = await TbSettingsPad.GetTbSettings({settingtype:5});
            this.isPrint = res.settingContent.isPut;
        }else{
            let res = await TbShopReceiptTemplate.GetTbShopReceiptTemplate({
                shopNo:shopInfo.shopNo,
                shopId:shopInfo.id
            })
            if(res.contentJson){
                this.isPrint = res.autoPrint;
            }
        }
    }
    /**获取收银配置 */
    async getPaySet(){
        let res = await TbSettingsPad.GetTbSettings({settingtype:2});
        this.paySetting = res.settingContent;
        this.isGroupPay = res.settingContent.multiplePay;
    }
    /**获取更多支付方式配置 */
    async getMorePaySet(){
        let res = await TbSettingsPad.GetTbSettings({settingtype:14});
        this.morePaySetting = res.settingContent;
        this.isHasMorePay = res.settingContent.offlineAlipay.isSelect||res.settingContent.offlineWeChat.isSelect;
        this.hasOfflineWeChat = res.settingContent.offlineWeChat.isSelect;
        this.hasOfflineAlipay = res.settingContent.offlineAlipay.isSelect;
    }

    changeZdXL(item){
        this.clearCoupon();
        this.zdyhVal = item.value;
        this.showZdPopover = false;
        if(this.zdyhVal==1){
            this.isOnlyZdZk = false;
            this.discountPrice=Number(this.priceTotal);
            this.discount=0;
        }else{
            this.discountPrice=0;
            this.discount=100;
        }
        this.calcFun();
        setTimeout(()=>{
            this.setPayal();
        },2000)
    }
    /**获取收银员列表 */
    async getStaffList(id){
        let res = await TbShopAccount.GetTbShopAccountDropList({shopid:this.userInfo.shopId});
        let item = res.find(v=>v.id==id);
        this.staffList = res.length>8?res.filter(v=>v.id!=id).slice(0,6):res.filter(v=>v.id!=id);
        this.staffList.unshift(item);
        this.staffListAll = res;
        this.cashierId = id;
    }
    /**选择收银员 */
    chooseCashier(item){
        this.getStaffList(item.id)
    }

    /**键盘 */
    del() {
		if(this.value){
            let index = this.value.length;
            this.value = index==1?0: this.value.toString().slice(0,index-1);
        }else{
            this.value = 0;
        }
		this.finishFun();
	}
	number(number) {
		// this.$emit("number", number);
        if(number=='.'&&!this.isNeedDot) return;
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}
		this.finishFun();
	}
    clearFun(){
		this.value = null;
		this.finishFun();
    }
    finishFun(){
        let value = this.value?this.value:0;
        // let value = this.value;
        switch (this.inputType) {
            case 1:
                this.isFinishCalc = false;
                if(Number(value)<=Number(this.priceTotal)){
                    this.discountPrice = value;
                }else{
                    this.discountPrice = Number(this.priceTotal);
                }
                this.clearCoupon();
                this.calcFun();
                setTimeout(()=>{
                    this.setPayal();
                    this.calcMember();
                    this.isFinishCalc = true;
                },2000)
                break;
            case 2:
                this.clearCoupon();
                if(Number(value)<100){
                    this.discount = value;
                }else{
                    this.discount = 100;
                }
                this.calcFun();
                setTimeout(()=>{
                    this.setPayal();
                    this.calcMember();
                },2000)
                break;
            case 3:
                this.cashVal = value;
                /**判断是否超出应收 */
                this.$nextTick(()=>{
                    if(this.cashVal>this.receivables&&this.selectedPayType.length>1){
                       this.cashVal = this.receivables;
                       this.value = this.receivables;
                    }
                    this.calcOhterVal(1,this.cashVal)
                })
                break;
            case 4:
                this.vipVal = value;
                /**判断是否超出应收 */
                this.$nextTick(()=>{
                    let maxVal = Math.min(this.memberInfo.balance,this.receivables)
                    if(this.vipVal>maxVal){
                       this.vipVal = maxVal;
                       this.value = maxVal;
                    }
                    this.calcOhterVal(2,this.vipVal)
                })
                break;
            case 5:
                this.wechatVal = value;
                /**判断是否超出应收 */
                this.$nextTick(()=>{
                    if(this.wechatVal>this.receivables){
                       this.wechatVal = this.receivables;
                       this.value = this.receivables;
                    }
                    this.calcOhterVal(3,this.wechatVal)
                })
                break;
            case 6:
                this.aliVal = value;
                /**判断是否超出应收 */
                this.$nextTick(()=>{
                    if(this.aliVal>this.receivables){
                       this.aliVal = this.receivables;
                       this.value = this.receivables;
                    }
                    this.calcOhterVal(4,this.aliVal)
                })
                break;

            default:
                break;
        }
        this.isInputSelected = false;
        this.$forceUpdate();
    }
    /**组合支付、仅有2种，输入一种，自动算第二种，两者相加为应收 */
    calcOhterVal(nowType,nowVal){
        if(this.selectedPayType.length!=2) return;
        let otherType = this.selectedPayType.filter(v=>v!=nowType)[0];
        let otherVal = calculate.subtraction(this.receivables,nowVal);
        switch (otherType) {
            case 1:
                this.cashVal = otherVal;
                break;
            case 2:
                this.vipVal = Math.min(otherVal,this.memberInfo.balance);
                break;
            case 3:
                this.wechatVal = otherVal;
                break;
            case 4:
                this.aliVal = otherVal;
                break;

            default:
                break;
        }
    }
    /**选择支付方式，如果选择2种，自动算第二种 */
    calcOhterVal2(nowType){
        if(this.selectedPayType.length!=2) return;
        let otherType = this.selectedPayType.filter(v=>v!=nowType)[0];
        let otherVal = calculate.subtraction(this.receivables,this.receiptTotal);
        if(otherVal<0){
            this.setInputVal(nowType);
        }else{
            switch (nowType) {
                case 1:
                    this.cashVal = otherVal;
                    break;
                case 2:
                    this.vipVal = Math.min(this.receivables,this.memberInfo.balance);
                    this.calcOhterVal(nowType,this.vipVal);
                    break;
                case 3:
                    this.wechatVal = otherVal;
                    break;
                case 4:
                    this.aliVal = otherVal;
                    break;

                default:
                    break;
            }
        }
    }
    setPayal(){
        this.resetPayVal();
        this.$nextTick(()=>{
            // console.log('receivables',this.receivables);
            if(this.selectedPayType.some(v=>v==this.defaultPayType)){
                this.spFun(this.defaultPayType);
            }else{
                this.spFun(this.selectedPayType[0]);
            }
        })
    }
    spFun(val){
        switch (val) {
            case 1:
                this.cashVal = this.receivables;
                break;
            case 2:
                this.vipVal = Math.min(this.memberInfo.balance,this.receivables);
                break;
            case 3:
                this.wechatVal = this.receivables;
                break;
            case 4:
                this.aliVal = this.receivables;
                break;

            default:
                break;
        }
    }
    resetPayVal(){
        this.cashVal = 0;
        this.vipVal = 0;
        this.wechatVal = 0;
        this.aliVal = 0;
    }
    async calcFun(){
        let obj = {
            memberCouponId:this.memberCouponId,
            isSingle:this.isOnlyZdZk,
            isWholeOrderDiscount:this.zdyhVal==1?false:true,
            wholeOrderDiscountPrice: this.discountPrice==0?0:this.discountPrice?this.discountPrice:this.priceTotal,
            orderDiscount:this.discount? calculate.multiplication(this.discount,0.01):0,
            isDeduction:this.isDeduction,
            useIntegral:this.isDeduction?this.useIntegral:0,
            pointDeduction:this.isDeduction?this.pointDeduction:0,
        }
        this.$emit("calcFun",obj);
    }
    calcCoupon(item){
        let obj = {
            memberCouponId:item.id,
            isSingle:this.isOnlyZdZk,
            isWholeOrderDiscount:this.zdyhVal==1?false:true,
            wholeOrderDiscountPrice:  this.discountPrice==0?0:this.discountPrice?this.discountPrice:this.priceTotal,
            orderDiscount:this.discount? calculate.multiplication(this.discount,0.01):0,
            isDeduction:this.isDeduction,
            useIntegral:this.isDeduction?this.useIntegral:0,
            pointDeduction:this.isDeduction?this.pointDeduction:0,
        }
        this.$emit("calcCoupon",obj);
    }
    /**计算使用优惠券后的总额 */
    goBack(){
        Bus.$off('resultPayCode');
        Bus.$off('returnScanCouponResult');
        Bus.$off('payFalse');
        clearTimeout(this.pollTimer);
        this.pollTimer = null;
        this.$emit("goBack");
    }
    /**支付方式，输入框状态 */
    getInputStatus(type){
        let str = "";
        switch (type) {
            case 1:
                if(!this.selectedPayType.some(v=>v==1)){
                    str = "isDisable"
                }else{
                    if(this.inputType==3&&this.isInputSelected){
                        str="isActive"
                    }
                }
                break;
            case 2:
                if(!this.selectedPayType.some(v=>v==2)||this.selectedPayType.length==1&&this.selectedPayType.some(v=>v==2)){
                    str = "isDisable"
                }else{
                    if(this.inputType==4&&this.isInputSelected){
                        str="isActive"
                    }
                }
                break;
            case 3:
                if(!this.selectedPayType.some(v=>v==3)&&!this.selectedPayType.some(v=>v==4)||(!this.isGroupPay&&(this.selectedPayType.some(v=>v==3)||this.selectedPayType.some(v=>v==4)))||(this.selectedPayType.length==1&&(this.selectedPayType.some(v=>v==3)||this.selectedPayType.some(v=>v==4)))){
                    str = "isDisable"
                }else{
                    if((this.inputType==5||this.inputType==6)&&this.isInputSelected){
                        str="isActive"
                    }
                }
                break;

            default:
                break;
        }
        return str;
    }
    selectInputFocus(type){
        if(type==3&&this.getInputStatus(1)=='isDisable') return;
        if(type==4&&this.getInputStatus(2)=='isDisable') return;
        if((type==5||type==6)&&this.getInputStatus(3)=='isDisable') return;
        this.isNeedDot = type==2?false:true;
        this.inputType = type;
        this.isInputSelected = true;
        this.value = null;
    }
    selectMfocus(){
        if(this.selectedPayType.some(v=>v==3)){
            this.selectInputFocus(5)
        }
        else if(this.selectedPayType.some(v=>v==4)){
            this.selectInputFocus(6)
        }
    }
    selectZfocus(){
        if(this.getZdStatus()=='isDisable') return;
        if(this.zdyhVal==1){
            this.selectInputFocus(1)
        }
        else if(this.zdyhVal==2){
            this.selectInputFocus(2)
        }
    }
    /**选择支付方式 */
    choosePayMethod(type){
        switch (type) {
            case 1:
                this.chargePayFun(1);
                break;
            case 2:
                if(this.getVipPayStatus()=="isDisable") return;
                this.chargePayFun(2);
                break;
            case 3:
                if(this.getWechatPayStatus()=="isDisable"){
                    if(!this.auditInfo.shopNo){
                        // this.tipTitle = "操作提醒";
                        // this.tipText = `尚未开通扫码支付收银功能`;
                        // this.btnNums=1;
                        // this.confirmText = "确认";
                        // this.cancelText = ""
                        // this.tipType = 2;
                        // this.tipShow = true;
                        this.uAuthTipFun(1);
                    }
                    else if(this.auditInfo.shopNo&&this.auditInfo.approveStatus!=3){
                        this.uAuthTipFun(2)
                    }
                    return;
                };
                this.aliVal = 0;
                this.selectedPayType = this.selectedPayType.filter(v=>v!=4);
                this.chargePayFun(3);
                break;
                case 4:
                if(this.getAliPayStatus()=="isDisable"){
                    if(!this.auditInfo.shopNo){
                        // this.tipTitle = "操作提醒";
                        // this.tipText = `尚未开通扫码支付收银功能`;
                        // this.btnNums=1;
                        // this.confirmText = "确认";
                        // this.cancelText = ""
                        // this.tipType = 2;
                        // this.tipShow = true;
                        this.uAuthTipFun(1);
                    }
                    else if(this.auditInfo.shopNo&&this.auditInfo.alipayApproveStatus!=3){
                        this.uAuthTipFun(3)
                    }
                    return;
                };
                this.wechatVal = 0;
                this.selectedPayType = this.selectedPayType.filter(v=>v!=3);
                this.chargePayFun(4);
                break;

            default:
                break;
        }
        this.isInputSelected = false;
    }
    uAuthTipFun(type){
        switch (type) {
            case 1:
                this.$refs['openingPrompt'].showFun();
                break;
            case 2:
                this.tipTitle = "操作提醒";
                this.tipText = `微信支付认证资料已提交，平台正在审核中，请耐心等待！`;
                this.btnNums=1;
                this.confirmText = "确认";
                this.cancelText = ""
                this.tipType = 2;
                this.tipShow = true;
                break;
            case 3:
                this.tipTitle = "操作提醒";
                this.tipText = `支付宝支付认证资料已提交，平台正在审核中，请耐心等待！`;
                this.btnNums=1;
                this.confirmText = "确认";
                this.cancelText = ""
                this.tipType = 2;
                this.tipShow = true;
                break;

            default:
                break;
        }
    }
    chargePayFun(val){
        this.inputType = null;
        if(!this.isGroupPay){
            if(!this.selectedPayType.some(v=>v==val)){
                this.selectedPayType=[val];
                this.setInputVal(val);
            }
        }else{
            if(!this.selectedPayType.some(v=>v==val)){
                if(this.selectedPayType.length==3) return;
                this.selectedPayType.push(val);
                if(this.selectedPayType.length==1&&(val==3||val==4)){
                    this.setInputVal(val);
                }
                this.calcOhterVal2(val)

            }else{
                if(this.selectedPayType.length>1){
                    this.calcOhterVal(val,0);
                    this.clearInputVal(val);
                    this.selectedPayType = this.selectedPayType.filter(v=>v!=val);
                }
            }
        }
    }
    setInputVal(val){
        switch (val) {
            case 1:
                this.cashVal = this.receivables;
                this.vipVal = 0;
                this.wechatVal = 0;
                this.aliVal = 0;
                break;
            case 2:
                this.cashVal = 0;
                this.vipVal = Math.min(this.receivables,this.memberInfo.balance);
                this.wechatVal = 0;
                this.aliVal = 0;
                break;
            case 3:
                this.cashVal = 0;
                this.vipVal = 0;
                this.wechatVal = this.receivables;
                this.aliVal = 0;
                break;
            case 4:
                this.cashVal = 0;
                this.vipVal = 0;
                this.wechatVal = 0;
                this.aliVal = this.receivables;
                break;

            default:
                break;
        }
    }

    clearInputVal(val){
        switch (val) {
            case 1:
                this.cashVal = 0;
                break;
            case 2:
                this.vipVal = 0;
                break;
            case 3:
                this.wechatVal = 0;
                break;
            case 4:
                this.aliVal = 0;
                break;

            default:
                break;
        }

    }
    /**会员支付输入框-状态 */
    getVipPayStatus(){
        let str = "";
        if(!this.memberInfo.id||(this.memberInfo.id&&this.memberInfo.balance==0)){
            str="isDisable";
        }
        if(this.selectedPayType.some(v=>v==2)){
            str="isActive"
        }
        return str;
    }
    /**微信支付输入框-状态 */
    getWechatPayStatus(){
        let str = "";
        if(!this.isWechat){
            str="isDisable";
        }
        if(this.selectedPayType.some(v=>v==3)){
            str="isActive"
        }
        return str;
    }
    getAliPayStatus(){
        let str = "";
        if(!this.isAli){
            str="isDisable";
        }
        if(this.selectedPayType.some(v=>v==4)){
            str="isActive"
        }
        return str;
    }
    onlyZdZkChange(){
        this.clearCoupon();
        this.calcFun();
        setTimeout(()=>{
            this.setPayal();
        },2000)
    }
    /**清空优惠券 */
    clearCoupon(){
        this.memberCouponId = "";
        this.couponName = "";
        this.couponInfo = {};
        this.yhAmount = 0;
        localStorage.removeItem("gwByCoupon");
        localStorage.removeItem("receivablesByCoupon");
    }
    /**积分抵扣输入框-状态 */
    getIntergalStatus(){
        let str = "";
        if(!this.memberInfo.id||(this.memberInfo.id&&!this.memberIntegalSetting.isOpen)||(this.memberInfo.id&&this.memberIntegalSetting.isOpen&&this.useIntegral==0)){
            str="isDisable";
        }
        if(this.isDeduction){
            str="isActive"
        }
        return str;
    }
    /**整单优惠输入框-状态 */
    getZdStatus(){
        let str = "";
        if(this.isDeduction){
            str="isDisable"
        }
        if((this.inputType==1||this.inputType==2)&&this.isInputSelected&&!this.isDeduction){
            str="isActive";
        }
        return str;
    }
    getZdChangeStatus(){
        let str = "";
        let arr = this.gwList.filter(v=>v.isDiscount&&!v.isNoCode&&!v.isGift)
        if(this.isDeduction||arr.length==0){
            str="isDisable"
        }
        return str;
    }
    /**提示弹窗 */
    async tipConfirm(){
        if(this.tipType==1){

        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }
    /**选择优惠券 */
    async chooseCoupon(){
        if(!this.memberInfo.id) return;
        if(this.isDeduction) return;
        if(this.isGetChangePrice) return;
        if(this.gwList.some(v=>v.isGift)){
            Toast("购物车中存在赠品，无法使用优惠券！");
            return
        }
        if(!this.memberCouponId){
            this.couponReceivables = this.receivablesNoMl;
            await this.getCouponList();
        }else{
            if(this.couponList.availableList.length==0){
                let defaultArr=this.gwList;
                let gwList = localStorage.getItem("gwByCoupon")?JSON.parse(localStorage.getItem("gwByCoupon")):defaultArr;
                this.couponReceivables = localStorage.getItem("receivablesByCoupon")?Number(localStorage.getItem("receivablesByCoupon")):this.receivablesNoMl;
                let res = await TbCoupon.GetSettlementCouponList({
                    memberId:this.memberInfo.id,
                    goodsList:gwList.map(v=>{
                        return{
                            goodsId:v.id,
                            articleNo:v.articleNo,
                            goodsPrice:v.finalPrice,
                            isOriginal:v.isOriginal,
                            quantity:v.num
                        }
                    })
                })
                this.couponList.availableList = res.availableList;
                this.couponList.notAvailableList = res.notAvailableList;
                this.couponList.gwList = gwList;
            }
        }
        if(this.couponList.availableList.length==0){
            this.tipTitle = "操作提醒";
            this.tipText = `暂无优惠券`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 1;
            this.tipShow = true;
            return;
        }
        this.showCoupon = true;
    }
    /**获取优惠券列表 */
    async getCouponList(){
        let res = await TbCoupon.GetSettlementCouponList({
            memberId:this.memberInfo.id,
            goodsList:this.gwList.map(v=>{
                return{
                    goodsId:v.id,
                    articleNo:v.articleNo,
                    goodsPrice:v.finalPrice,
                    isOriginal:v.isOriginal,
                    quantity:v.num
                }
            })
        })
        this.couponList.availableList = res.availableList;
        this.couponList.notAvailableList = res.notAvailableList;
        this.couponList.gwList = this.gwList;
    }
    /**优惠券弹窗 */
    closeCoupon(){
        this.showCoupon = false;
        this.$nextTick(()=>{
            // window.webkit.messageHandlers.getFocus.postMessage('getFocus');
        })
    }
    async confirmCoupon(item){
        this.couponInfo = item;
        this.yhAmount = item.yhAmount;
        if(!this.memberCouponId){
            localStorage.setItem('gwByCoupon',JSON.stringify(this.gwList));
            localStorage.setItem('receivablesByCoupon',JSON.stringify(this.receivablesNoMl));
        }
        this.memberCouponId = item.id;
        this.couponName = item.coupon.name;

        await this.calcFun();
        setTimeout(()=>{
            this.setPayal();
            this.calcMember();
        },2000)
    }
    closeScan(){
        this.scanShow = false;
        this.isCouponOff = false;
        Bus.$emit('watchCouponScan',false)
    }
    scanFun(){
        if(!this.memberInfo.id) return;
        if(this.isDeduction) return;
        if(this.isGetChangePrice) return;
        if(this.gwList.some(v=>v.isGift)){
            Toast("购物车中存在赠品，无法使用优惠券！");
            return
        }
        this.scanShow = true;
        this.$nextTick(()=>{
            Bus.$emit('watchCouponScan',true);

        })
    }
    chooseOther(){
        this.scanShow = true;

    }
    /**收银员弹窗 */
    closeCashierFun(){
        this.popStaffId = "";
        this.diaCashierShow = false;

    }
    choosePopStaff(item){
        this.popStaffId = item.id;
    }
    cashierSaveFun(){
        if(!this.popStaffId) return;
        this.getStaffList(this.popStaffId);
        this.closeCashierFun();
    }
    showStaffList(){
        this.popStaffId = "";
        this.diaCashierShow = true;
    }
    /**确认收款 */
    async confirmSk(moreInfo=null){
        if(!this.isFinishCalc){
            Toast("系统计算中请稍后...")
            return;
        }
        this.orderInfo = {};
        let receiptTotal = moreInfo?moreInfo.receivables:this.receiptTotal;
        let selectedPayType = moreInfo?moreInfo.selectedPayType:this.selectedPayType;
        let cashVal=moreInfo?moreInfo.cashVal:this.cashVal;
        let vipVal=moreInfo?moreInfo.vipVal:this.vipVal;
        let wechatVal=moreInfo?moreInfo.wechatVal:this.wechatVal;
        let aliVal=moreInfo?moreInfo.aliVal:this.aliVal;
        let xlWechatVal=moreInfo?moreInfo.xlWechatVal:0;
        let xlAliVal=moreInfo?moreInfo.xlAliVal:0;
        let moneyInfo = moreInfo?{
            cashVal:cashVal,
            vipVal:vipVal,
            wechatVal:wechatVal,
            aliVal:aliVal,
            xlWechatVal:xlWechatVal,
            xlAliVal:xlAliVal,
        }:null;
        if(this.isSking) return;
        this.isSking = true;
        if(this.receivables!=receiptTotal){
            /**只有现金一种支付方式的时候，不用判断实收应收是否相等 */
            if(selectedPayType.length==1&&selectedPayType.some(v=>v==1)){
                if(this.receivables>receiptTotal){
                    Toast("本单实收小于本单应收");
                    this.isSking = false;
                    return;
                }
            }else{
                Toast("本单实收不等于本单应收");
                this.isSking = false;
                return;
            }
        }
        if(vipVal&&Number(vipVal)>Number(this.memberInfo.balance)){
            Toast("会员余额不足");
            this.isSking = false;
            return;
        }
        if(!this.cashierId){
            Toast("请选择收银员")
            this.isSking = false;
            return;
        }
        let paymentMethod= 0;
        if(this.getPayMethod(selectedPayType,moneyInfo)==0){
            if(selectedPayType.some(v=>v==1)){
                paymentMethod=2
            }else{
                paymentMethod=1
            }
        }else{
            paymentMethod = this.getPayMethod(selectedPayType,moneyInfo);
        }
        // console.log('paymentMethod',paymentMethod,selectedPayType,this.getPayMethod(selectedPayType));

        this.orderInfo = {
            paymentMethod:paymentMethod,
            receivables:receiptTotal,
            giveChange:moreInfo?moreInfo.giveChange:this.changeVal,
            cardBalance:this.memberInfo.id?this.memberInfo.balance:0,
            cardSurplusBalance:this.memberInfo.id? calculate.subtraction(this.memberInfo.balance,vipVal):0,
            cashVal:cashVal,
            vipVal:vipVal,
            wechatVal:wechatVal,
            aliVal:aliVal,
            xlWechatVal:xlWechatVal,
            xlAliVal:xlAliVal,
        }
        console.log('orderInfo',this.orderInfo);
        await this.postorder();
        this.$nextTick(async ()=>{
            this.orderInfo = Object.assign({},this.orderInfo,{
                cashVal:this.orderInfo.cashPart,
                vipVal:this.orderInfo.cardPart,
                wechatVal:this.orderInfo.weChatPart,
                aliVal:this.orderInfo.alipayPart,
                xlWechatVal:this.orderInfo.offlineWeChat,
                xlAliVal:this.orderInfo.offlineAlipayPart,
            })
            await this.$refs['payPanel'].showFun();

            // window.webkit.messageHandlers.getFocus.postMessage('getFocus');
        })
    }
    // Pad新增订单-预支付操作
    async postorder(){
            // console.log('tssss',this.orderInfo);
            let paymentMethod= this.orderInfo.paymentMethod;
            // if(this.getPayMethod()==0){
            //     if(this.selectedPayType.some(v=>v==1)){
            //         paymentMethod=2
            //     }else{
            //         paymentMethod=1
            //     }
            // }else{
            //     paymentMethod = this.getPayMethod();
            // }
            let obj  = {
                shopId:this.userInfo.shopId,
                memberCouponId:this.memberCouponId,
                isSingle:this.isOnlyZdZk,
                memberId:this.memberInfo.id?this.memberInfo.id:'',
                memberPhone:this.memberInfo.phone?this.memberInfo.phone:'',
                num:this.gwList.length,
                paymentMethod:paymentMethod,
                paymentType:((paymentMethod>4&&paymentMethod<12)||paymentMethod>14)?2:1,
                isWholeOrderDiscount: this.zdyhVal==2?true:false,
                wholeOrderDiscountPrice: this.discountPrice==0?0:this.discountPrice?this.discountPrice:this.priceTotal,
                cashierId:this.cashierId?this.cashierId:'',
                cashPart:((paymentMethod>4&&paymentMethod<12)||paymentMethod>14)?Number(this.orderInfo.cashVal)>0?Number(this.orderInfo.cashVal):0:0,
                cardPart:((paymentMethod>4&&paymentMethod<12)||paymentMethod>14)?Number(this.orderInfo.vipVal)>0?Number(this.orderInfo.vipVal):0:0,
                weChatPart:((paymentMethod>4&&paymentMethod<12)||paymentMethod>14)?Number(this.orderInfo.wechatVal)>0?Number(this.orderInfo.wechatVal):0:0,
                alipayPart:((paymentMethod>4&&paymentMethod<12)||paymentMethod>14)?Number(this.orderInfo.aliVal)>0?Number(this.orderInfo.aliVal):0:0,
                offlineWeChat:((paymentMethod>4&&paymentMethod<12)||paymentMethod>14)?Number(this.orderInfo.xlWechatVal)>0?Number(this.orderInfo.xlWechatVal):0:0,
                offlineAlipayPart:((paymentMethod>4&&paymentMethod<12)||paymentMethod>14)?Number(this.orderInfo.xlAliVal)>0?Number(this.orderInfo.xlAliVal):0:0,
                actualPayment:Number(this.orderInfo.receivables),
                orderDiscount:this.discount?calculate.multiplication(this.discount,0.01) :0,
                isDeduction:this.isDeduction,
                useIntegral:this.isDeduction?this.useIntegral:0,
                pointDeduction:this.isDeduction?this.pointDeduction:0,
                sourceType:1,
                remark:localStorage.getItem('orderRemark')?localStorage.getItem('orderRemark'):'',
                items: this.gwList.map(v=>{
                    return{
                        shopId:v.shopId,
                        goodId:v.id,
                        goodsItemId:v.goodsItemId,
                        num:v.num,
                        price:v.isNoCode?v.sellingPrice:0,
                        articleNo:v.articleNo,
                        giftNum:v.isGift?v.num:0,
                        isGift:v.isGift,
                        isChangePrice:v.isChangePrice?v.isChangePrice:false,
                        discountPrice:v.isNoCode?0:Number(v.discountPrice),
                        goodDiscount:v.goodDiscount,
                        isDiscount:v.isDiscount,
                        isMemberDiscount:v.isMemberDiscount,
                        isIntegral:v.isIntegral,
                        showPrice_DiscountPrice:v.isNoCode?v.sellingPrice:Number(v.discountPrice),
                    }
                })
            }
            try {
                this.count = 40;
                let res = await TbOrderPad.PostOrderV4(obj);
                this.btnloading = false;
                this.orderInfo = res;
                this.isSking = false;
                localStorage.removeItem('mulChangePricegSet');
            } catch (error) {
                this.btnloading = false;
                this.isSking = false;
                localStorage.removeItem('mulChangePricegSet');
            }

        }
        /**匹配支付方式
         * 支付方式
            0 = None，缺省值
            1 = MemberCard，会员卡
            2 = Cash，现金
            3 = Wechat，微信
            4 = AliPay，支付宝
            5 = Cash_Card_WeChat，现金+会员卡+微信
            6 = Cash_Card_Alipay，现金+会员卡+支付宝
            7 = Cash_WeChat，现金+微信
            8 = Cash_Alipay，现金+支付宝
            9 = Card_WeChat，会员卡+微信
            10 = Card_Alipay，会员卡+支付宝
            11 = Cash_Card，现金+会员卡
            12 = Mix，混合支付
            13 = OfflineWeChat，线下微信
            14 = OfflineAlipay，线下支付宝
            15 = Cash_OfflineAlipay，现金+线下支付宝
            16 = MemberCard_OfflineAlipay，会员卡+线下支付宝
            17 = Cash_OfflineWeChat，现金+线下微信
            18 = MemberCard_OfflineWeChat，会员卡+线下微信
            19 = OfflineWeChat_OfflineAlipay，线下微信+线下支付宝
            20 = Cash_MemberCard_OfflineAlipay，现金+会员卡+线下支付宝
            21 = Cash_MemberCard_OfflineWeChat，现金+会员卡+线下微信
            22 = Cash_OfflineAlipay_OfflineWeChat，现金+线下支付宝+线下微信
            23 = MemberCard_OfflineAlipay_OfflineWeChat，会员卡+线下支付宝+线下微信
         */
        getPayMethod(selectedPayTypeArr=this.selectedPayType,moneyInfo=null){
            // console.log('selectedPayTypeArr',selectedPayTypeArr);
            let str = 0;
            let selectedPayType = selectedPayTypeArr.length>1? this.filterSelectedPayType(selectedPayTypeArr,moneyInfo):selectedPayTypeArr;
            console.log('ssssaasdas',selectedPayType);

            if(this.arraysEqual(selectedPayType,[1])){
                str = 2;
            }else if(this.arraysEqual(selectedPayType,[2])){
                str = 1;
            }else if(this.arraysEqual(selectedPayType,[3])){
                str = 3;
            }else if(this.arraysEqual(selectedPayType,[4])){
                str = 4;
            }else if(this.arraysEqual(selectedPayType,[1,2,3])){
                str = 5;
            }else if(this.arraysEqual(selectedPayType,[1,2,4])){
                str = 6;
            }else if(this.arraysEqual(selectedPayType,[1,3])){
                str = 7;
            }else if(this.arraysEqual(selectedPayType,[1,4])){
                str = 8;
            }else if(this.arraysEqual(selectedPayType,[2,3])){
                str = 9;
            }else if(this.arraysEqual(selectedPayType,[2,4])){
                str = 10;
            }else if(this.arraysEqual(selectedPayType,[1,2])){
                str = 11;
            }else if(this.arraysEqual(selectedPayType,[5])){
                str = 13;
            }else if(this.arraysEqual(selectedPayType,[6])){
                str = 14;
            }else if(this.arraysEqual(selectedPayType,[1,6])){
                str = 15;
            }else if(this.arraysEqual(selectedPayType,[2,6])){
                str = 16;
            }else if(this.arraysEqual(selectedPayType,[1,5])){
                str = 17;
            }else if(this.arraysEqual(selectedPayType,[2,5])){
                str = 18;
            }else if(this.arraysEqual(selectedPayType,[5,6])){
                str = 19;
            }else if(this.arraysEqual(selectedPayType,[1,2,6])){
                str = 20;
            }else if(this.arraysEqual(selectedPayType,[1,2,5])){
                str = 21;
            }else if(this.arraysEqual(selectedPayType,[1,5,6])){
                str = 22;
            }else if(this.arraysEqual(selectedPayType,[2,5,6])){
                str = 23;
            }
            return str;
        }
        /**判断数组是否相等 */
        arraysEqual(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            if (a.length != b.length) return false;
            return !a.some((item, index) => item !== b[index]);
        }
        /**收银方式过滤掉无值项 */
        filterSelectedPayType(selectedPayTypeArr,moneyInfo=null){
            let val = [];
            if(moneyInfo){
                selectedPayTypeArr.forEach(v=>{
                    if(v==1&&Number(moneyInfo.cashVal)>0){
                        val.push(1)
                    }
                    if(v==2&&Number(moneyInfo.vipVal)>0){
                        val.push(2)
                    }
                    if(v==3&&Number(moneyInfo.wechatVal)>0){
                        val.push(3)
                    }
                    if(v==4&&Number(moneyInfo.aliVal)>0){
                        val.push(4)
                    }
                    if(v==5&&Number(moneyInfo.xlWechatVal)>0){
                        val.push(5)
                    }
                    if(v==6&&Number(moneyInfo.xlAliVal)>0){
                        val.push(6)
                    }
                })
            }else{
                selectedPayTypeArr.forEach(v=>{
                    if(v==1&&Number(this.cashVal)>0){
                        val.push(1)
                    }
                    if(v==2&&Number(this.vipVal)>0){
                        val.push(2)
                    }
                    if(v==3&&Number(this.wechatVal)>0){
                        val.push(3)
                    }
                    if(v==4&&Number(this.aliVal)>0){
                        val.push(4)
                    }
                })
            }
            if(val.length>0){
                val.sort((a,b)=>a-b);
            }
            return val;
        }
        /**支付弹窗 */
        closePay(){
            if(this.$refs['payPanel']){
                window.clearInterval(this.$refs['payPanel'].interval);
                window.clearInterval(this.$refs['payPanel'].interval2);
                console.log('vlear');

            }
            this.payShow = false;
        }
        // 会员卡支付
        async payFun(){
            if(this.btnloading) return;
            // await this.postorder();
            if(this.orderInfo.id){
                /**支付方式含支付宝/微信 */
                if(this.orderInfo.paymentMethod==3||this.orderInfo.paymentMethod==4||this.orderInfo.paymentMethod==5||this.orderInfo.paymentMethod==6||this.orderInfo.paymentMethod==7||this.orderInfo.paymentMethod==8||this.orderInfo.paymentMethod==9||this.orderInfo.paymentMethod==10){

                }else{
                    this.btnloading = true;
                    try {
                        let res = await TbOrderPad.OrderPayV5({
                            authCode:'',
                            id:this.orderInfo.id,
                            spbillCreateIp:''
                        })
                        // await this.printTest(this.orderInfo.id);
                        this.btnloading = false;
                        if(this.$refs['payPanel']){
                            this.$refs['payPanel'].closeFun();
                        }
                        this.payResult = res.isSuccessPay;
                        this.resultShow = true;
                        this.morePayShow = false;
                        this.errorMessage = res.err_Msg;
                        this.payMethodChangeMsg = res.payMethodChangeMsg;
                        this.isShowQueryBot = res.isShowQueryBot;
                    } catch (error) {
                        this.errorCode = error.errorCode;
                        this.btnloading = false;
                        this.payResult = false;
                        this.isShowQueryBot = false;
                        if(this.$refs['payPanel']){
                            this.$refs['payPanel'].closeFun();
                        }
                        this.resultShow = true;
                    }
                }
            }
        }
        /**支付结果弹窗 */
        closeResult(){
            this.resultShow = false;
        }
        //查看异常订单详情
        viewFailOrderDetail(){
          this.payovertimeShow = false;
          this.goDetail();
        }
        //关闭"未获取到支付结果"弹窗
        onPayovertimeClose(){
          this.payovertimeShow = false;
        }
        goDetail(){
          this.$router.push(`/pad/report/index?tag=order&curZL=3&id=${this.orderInfo.id}&orderStatus=0`)
        }
        rePay(){
            this.tipTitle = "重新收银提醒";
            this.tipText = `确定重新收银后，当前销售订单将自动关闭并失效。系统会为您重新生成一条与原订单内容一致的新销售订单，您只需要点
一下“收银”即可直接进入结算流程。确认重新收银吗?`;
            this.btnNums=2;
            this.confirmText = "确定重新收银";
            this.cancelText = "取消"
            this.tipType = 3;
            this.tipShow = true;
        }
        async confimrSuccess(){
            await this.printTest(this.orderInfo.id);

        }

        closeCouponPop(){
            this.couponShow = false;
            this.$nextTick(()=>{
                Bus.$emit('watchCouponScan',false);
            })
        }
        resetScan(){
            this.isCouponOff = false;
            this.$nextTick(()=>{
                Bus.$emit('watchCouponScan',true);

            })
        }

        async printTest(id){
            if(!this.isPrint){
                this.isPrintLoading = false;
                 this.resultShow = false;
                 location.reload();
                return;
            }
            if(this.isPrintLoading) return;
            this.isPrintLoading = true;
            this.prBtnTxt = "打印小票中，请稍后..."
            let address = localStorage.getItem('padShopInfo')?JSON.parse(localStorage.getItem('padShopInfo')).address:''
            let resSetting= await TbSettingsPad.GetTbSettings({
            settingtype: 5,
            });
            let resOrder = await TbOrderPad.GetOrderById({id:id});

            let form = Object.assign({},{settingContent:resSetting.settingContent},{orderInfo:Object.assign({},resOrder,{address:address})},{type:'receipt'})
            console.log('form',form);
            let time = 5000*resSetting.settingContent.putNum;
            let shopInfo = await TbShop.GetTbShopById({id:this.userInfo['shopId']});
            let resShop = await TbShop.GetInitShopInfo({shopid:shopInfo.id});
            let isnewReceipt = resShop.webShopReceiptTemplateType;
            let isOpen = resOrder.paymentMethod==2||resOrder.paymentMethod==5||resOrder.paymentMethod==6||resOrder.paymentMethod==7||resOrder.paymentMethod==8
             ||resOrder.paymentMethod==11||resOrder.paymentMethod==15||resOrder.paymentMethod==17||resOrder.paymentMethod==20||resOrder.paymentMethod==21||resOrder.paymentMethod==22;
            if(isnewReceipt==0){
                if(form.settingContent.putNum>0){
                    for(let i =1;i<=form.settingContent.putNum;i++){
                        setTimeout(()=>{
                            const canvas = this.$refs['barcodeCanvas'];
                            JsBarcode('canvas', form.orderInfo.orderNo, {
                                format: "CODE128", // 可以选择不同的格式，例如 CODE128, CODE39 等
                                lineColor: "#000",
                                width: 3,
                                height: 100,
                                displayValue: false
                            });
                            let barcodeImage = canvas.toDataURL("image/png"); // 转换为Base64编码的PNG图像
                                PrintEvent1(form,barcodeImage,isOpen)

                        },3000)
                    }
                }
                setTimeout(()=>{
                    this.isPrintLoading = false;
                     this.resultShow = false;
                     location.reload();
                },time)
            }else{
                let res = await TbShopReceiptTemplate.GetTbShopReceiptTemplate({
                    shopNo:shopInfo.shopNo,
                    shopId:shopInfo.id
                })
                let padSetInfo= res;
                let form = Object.assign({},{settingContent:padSetInfo},{orderInfo:Object.assign({},resOrder,{address:address})},{type:'receipt'});
                let putNum = res.contentJson.receiptTemplateMore.printNum?res.contentJson.receiptTemplateMore.printNum:1;
                let time = 5000*putNum;
                setTimeout(()=>{
                    const canvas = this.$refs['barcodeCanvas'];
                    JsBarcode('canvas', form.orderInfo.orderNo, {
                        format: "CODE128", // 可以选择不同的格式，例如 CODE128, CODE39 等
                        lineColor: "#000",
                        width: 3,
                        height: 100,
                        displayValue: false
                    });
                    let barcodeImage = canvas.toDataURL("image/png"); // 转换为Base64编码的PNG图像
                    PrintEvent3(form,barcodeImage,putNum,isOpen)
                },3000)

                setTimeout(()=>{
                    this.isPrintLoading = false;
                     this.resultShow = false;
                     location.reload();
                },time)
            }
            localStorage.setItem('failPrintForm',JSON.stringify(form));

        }
        showMorePay(){
            this.morePayShow = true;
        }
        closeMore(){
            this.morePayShow = false;
        }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/settlementDesk.vue